module.exports = "/assets/image-right.jpg?2z/Qyem";